import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// useMe is the canonical hook for the current user. Components should
// derive role/isAdmin/hasFinancial from this rather than calling /api/me directly.
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: ApiClient.me
  })
}